import React from 'react';

/**
 * Kolega design-system — IconButton ("icon tile")
 * A 34×34 square control used in the top bar (theme toggle, notifications,
 * bug report, etc.). Surface-2 background with a subtle border; theme-aware
 * via the design tokens. An optional `badge` is rendered top-right.
 */
export interface IconButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'style'> {
  icon: React.ReactNode;
  /** Rendered absolutely in the top-right corner (e.g. an unread dot). */
  badge?: React.ReactNode;
  style?: React.CSSProperties;
}

export function IconButton({ icon, badge, style, ...rest }: IconButtonProps) {
  return (
    <button
      type="button"
      className="ds-icon-button"
      style={{
        position: 'relative',
        width: 34,
        height: 34,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: 'none',
        borderRadius: 'var(--radius-md)',
        background: 'var(--surface-2)',
        border: '1px solid var(--border-subtle)',
        color: 'var(--text-strong)',
        cursor: 'pointer',
        transition: 'background var(--dur-fast) var(--ease-out)',
        ...style,
      }}
      {...rest}
    >
      {icon}
      {badge}
    </button>
  );
}

export default IconButton;
